import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import StateContext from "../../contexts/StateContext";
import FormLicencesAssign from "../forms/FormLicencesAssign";

function AssignLicences(props) {
  const appState = useContext(StateContext);
  const history = useHistory();

  const targetGroup = appState.user.type === 'super-admin' ? 'Mandanten' : 'Institutionen';

  useEffect(() => {
    window.document.title = props.title;
  }, [props.title]);

  return (
    <main className="assignLicences">
      <h1 className="title">Kontingente zuweisen</h1>
      <p className="info">In diesem Bereich können Sie Ihren {targetGroup} Lizenzkontingente zuweisen.</p>
      <FormLicencesAssign
        usertype={appState.user.type}
        onCancel={e => {
          history.push('/');
        }}
      />
    </main>
  );
}
export default AssignLicences;
